import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, Type } from '@angular/core';
import { SectionEditorBridgeService } from '../../../services/section-editor-bridge.service';
import { BaseSectionEditorDirective } from '../base-section-editor.directive';
import { NbDialogService } from '@nebular/theme';
import { PreviewEditStoreService } from '../../../services/preview-edit-store.service';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GridCell, RowCell } from '@urbannex/storethemes';
import { EditorDialogComponent } from '../../dialogs/editor-dialog/editor-dialog.component';
import { EditState } from '../../../model';
import { Section } from '../../../editor-container/editor-model';

@Component({
  selector: 'kve-slider-editor',
  templateUrl: './slider-editor.component.html',
  styleUrls: ['./slider-editor.component.scss']
})
export class SliderEditorComponent extends BaseSectionEditorDirective implements OnInit {
  elementId: string;
  gridThumbnails: any[];
  gridThumbnails$: Subscription;
  cellIdsThumbs: any[];
  cellIdsThumbs$: Subscription;
  selectedCell: GridCell | RowCell;

  @Output() setListMode = new EventEmitter();

  destroy$: Subject<void> = new Subject<void>();

  constructor(sectionEditorBridge: SectionEditorBridgeService,
    private dialogService: NbDialogService,
    previewEditStoreService: PreviewEditStoreService) {
    super(sectionEditorBridge, previewEditStoreService)
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.gridThumbnails$ = this.sectionEditorBridge.getSectionThumbnails().pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        this.gridThumbnails = data;
      })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["selectedRenderedSection"]) {
      this.elementId = this.selectedRenderedSection.elementId;
      // this.section.contentType;
      // this.section.sectionData;
    }
  }

  open(options: any) {
    console.log(this.selectedSection);
    // image header footer link
    const action = options["action"];
    const imgSrc = options["imgSrc"];
    const cellId = options["cellId"];
    this.previewEditStoreService.setSelectedCell(cellId);
    this.resolveSelectedCell(cellId);

    let component: Type<any> = EditorDialogComponent;
    let title = "Title"
    switch (action) {
      case "image":
        component = EditorDialogComponent;
        title = "Edit Cell"
        break;

      default:
        break;
    }
    this.previewEditStoreService.updateEditState(EditState.EDITING);
    const dialogRef = this.dialogService.open(component, {
      context: {
        title: title,
        imgSrc: imgSrc,
        cellId: cellId,
        section: this.selectedSection,
        selectedCell: this.selectedCell,
        dialogWidth: 960
      },
    })

    dialogRef.onClose.subscribe((resp: GridCell) => {
      if (resp != undefined) {
        console.log(resp);
        console.log(this.cellIdsThumbs);
        const activeCell = this.cellIdsThumbs.find(cell => cell.cellId == resp.cellId);
        if (activeCell != null && activeCell != undefined) {
          activeCell.imgSrc = resp.imgSrc;
        }
        this.previewEditStoreService.selectedSection$.subscribe((section: Section) => {
          section.sectionData.isPreview = false;
        })
        this.previewEditStoreService.updateSelectedCell(resp);
        this.previewEditStoreService.updateEditState(EditState.UPDATED)
      }
    })
  }
  goBack(e) {
    this.setListMode.emit();
  }

  resolveSelectedCell(cellId) {
    const cells: GridCell[] = this.selectedSection.sectionData.rowCells;
    if (cells != undefined && cells.length > 0) {
      this.selectedCell = cells.find(cell => cell.cellId == cellId);
    }
  }

}
